export default __webpack_public_path__ + "static/media/check-in-banner.36917332.webp";